// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsWebMessengerConfigurationVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductRelationsRelationTypesItem = {
    Undefined: 'Undefined',
    Related: 'Related',
    RecentlyViewed: 'RecentlyViewed',
    Popular: 'Popular',
    Favourite: 'Favourite',
    Samples: 'Samples',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantDigitalPromotionsChannel = {
    Website: 'Website',
    MV7: 'MV7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantDigitalPromotionsPromotionTypesItem = {
    BestOffers: 'BestOffers',
    WhatsNew: 'WhatsNew',
    Hero: 'Hero',
    Campaign: 'Campaign',
    Category: 'Category',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsReplacementsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesProductsPricesRepositoryProductsPricesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsManufacturersVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesProductsLabelsRepositoryProductsLabelsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsLabelsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsLabelsProductLabelDomainsItem = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsIngredientsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsExpectedInboundsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantDeprecatedProductVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesProductsRepositoryProductsToolingBannersVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesProductsRepositoryProductsHashCodesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesProductsRepositoryProductsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ProductListingHeadersVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ProductListingsV2OrderBy = {
    Recommended: 'Recommended',
    Latest: 'Latest',
    HighestRating: 'HighestRating',
    LowestPrice: 'LowestPrice',
    HighestPrice: 'HighestPrice',
    HighestDiscount: 'HighestDiscount',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ProductListingsV2VisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ProductFacetsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ProductDetailPageDeliveryGuaranteesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductBundlesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductBundleVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsProductBoxVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptPriceVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductPriceVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7PersonalizedNutritionQuizQuestionsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7PersonalizedNutritionStartPageVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptPermissionVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductPermissionVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsBannerEnrichedPermanentTopAreaBannersBannerType = {
    PublicPage: 'PublicPage',
    PublicPageWithReferral: 'PublicPageWithReferral',
    Checkout: 'Checkout',
    MyPages: 'MyPages',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsBannerPermanentTopAreaBannersBannerTypesItem = {
    PublicPage: 'PublicPage',
    PublicPageWithReferral: 'PublicPageWithReferral',
    Checkout: 'Checkout',
    MyPages: 'MyPages',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsOlapicConfigurationOlapicType = {
    Category: 'Category',
    FrontPage: 'FrontPage',
    Gallery: 'Gallery',
    ProductDetails: 'ProductDetails',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsNavigationExpandedNavigationVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsNavigationNavigationVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7HomepageBestsellerProductsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7HomepageIconicProductsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsFrontPageVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsFrontPageBenefitBannerVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptsFormattedPricesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsFormattedPricesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsFooterVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsBannerFeedbackBenefitBannersBannerTypesItem = {
    ShareAndEarn: 'ShareAndEarn',
    Cashback: 'Cashback',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantEditorialArticlesArticleType = {
    BeautyEdit: 'BeautyEdit',
    RelatedToProduct: 'RelatedToProduct',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsEditorialEditorialPagesChannel = {
    Web: 'Web',
    Mobile: 'Mobile',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7PersonalEditorialPagesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7PersonalEditorialLandingPagesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantCustomerConfirmationMetadataConfirmationContextType = {
    Profile: 'Profile',
    SelfRegistration: 'SelfRegistration',
    SponsorRegistration: 'SponsorRegistration',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantAvailableDirectReportsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantFilteredConceptRecommendationsType = {
    Collaborative: 'Collaborative',
    Content: 'Content',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptRecommendationsType = {
    Collaborative: 'Collaborative',
    Content: 'Content',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesConceptsLabelsRepositoryConceptsLabelsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesConceptsRepositoryConceptsHashCodesVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7ModulesConceptsRepositoryConceptsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantDeprecatedConceptVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptLabelsVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptLabelsConceptLabelDomainsItem = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsChatBotPageMetadataVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7CategoryProductListingOrderBy = {
    Recommended: 'Recommended',
    Latest: 'Latest',
    HighestRating: 'HighestRating',
    LowestPrice: 'LowestPrice',
    HighestPrice: 'HighestPrice',
    HighestDiscount: 'HighestDiscount',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7CategoryProductListingVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsCatalogueOverviewCatalogueTypesItem = {
    None: 'None',
    DigitalCurrent: 'DigitalCurrent',
    DigitalNext: 'DigitalNext',
    LocalCustom: 'LocalCustom',
    Lookbook: 'Lookbook',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsCatalogueOverviewVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantRewardShopConfigurationsCustomerCategory = {
    Anonymous: 'Anonymous',
    Consultant: 'Consultant',
    EndConsumer: 'EndConsumer',
    Invitation: 'Invitation',
    Employee: 'Employee',
    EndCustomer: 'EndCustomer',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7BrandProductListingOrderBy = {
    Recommended: 'Recommended',
    Latest: 'Latest',
    HighestRating: 'HighestRating',
    LowestPrice: 'LowestPrice',
    HighestPrice: 'HighestPrice',
    HighestDiscount: 'HighestDiscount',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantApplicationsMv7BrandProductListingVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantConceptAvailabilityVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductsAvailabilityVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var GetTenantProductAvailabilityVisitorSegment = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticTermsTermHtmlDtoTermsSource = {
    Sitecore: 'Sitecore',
    OneTrust: 'OneTrust',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticSubscriptionsSubscriptionTypeDtoCategory = {
    Wellness: 'Wellness',
    LifePlus: 'LifePlus',
    HairCare: 'HairCare',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticSocialMediaLinksSocialMediaLinkType = {
    Facebook: 'Facebook',
    VKontakte: 'VKontakte',
    Twitter: 'Twitter',
    YouTube: 'YouTube',
    Instagram: 'Instagram',
    Pinterest: 'Pinterest',
    Odnoklassniki: 'Odnoklassniki',
    Weibo: 'Weibo',
    QQ: 'QQ',
    Youku: 'Youku',
    Line: 'Line',
    WeChat: 'WeChat',
    Telegram: 'Telegram',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticShoppingOrderTrackingsDtoCurrentStatus = {
    Unknown: 'Unknown',
    Create: 'Create',
    Cancel: 'Cancel',
    Print: 'Print',
    Pick: 'Pick',
    Ship: 'Ship',
    CourierTakeover: 'CourierTakeover',
    TakenByCourier: 'TakenByCourier',
    OutForDelivery: 'OutForDelivery',
    ReturnedToSender: 'ReturnedToSender',
    ToBeReturnedToSender: 'ToBeReturnedToSender',
    ReadyForPickup: 'ReadyForPickup',
    PickedUpBy: 'PickedUpBy',
    HandoverFailed: 'HandoverFailed',
    CourierHandover: 'CourierHandover',
    Deliver: 'Deliver',
    EstimatedDelivery: 'EstimatedDelivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticShoppingOrderTrackingStepDtoStatus = {
    Unknown: 'Unknown',
    Create: 'Create',
    Cancel: 'Cancel',
    Print: 'Print',
    Pick: 'Pick',
    Ship: 'Ship',
    CourierTakeover: 'CourierTakeover',
    TakenByCourier: 'TakenByCourier',
    OutForDelivery: 'OutForDelivery',
    ReturnedToSender: 'ReturnedToSender',
    ToBeReturnedToSender: 'ToBeReturnedToSender',
    ReadyForPickup: 'ReadyForPickup',
    PickedUpBy: 'PickedUpBy',
    HandoverFailed: 'HandoverFailed',
    CourierHandover: 'CourierHandover',
    Deliver: 'Deliver',
    EstimatedDelivery: 'EstimatedDelivery',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticSharedLinkDtoType = {
    Product: 'Product',
    Brand: 'Brand',
    PLpage: 'PLpage',
    EditorialArticle: 'EditorialArticle',
    Invite: 'Invite',
    Custom: 'Custom',
    Category: 'Category',
    NewProducts: 'NewProducts',
    Catalogue: 'Catalogue',
    Campaign: 'Campaign',
    NovageSkincareAdvisor: 'NovageSkincareAdvisor',
    EditorialCampaign: 'EditorialCampaign',
    Ingredient: 'Ingredient',
    SignIn: 'SignIn',
    Frontpage: 'Frontpage',
    RegistrationPage: 'RegistrationPage',
    InvitationOffer: 'InvitationOffer',
    Brands: 'Brands',
    FoundationFinder: 'FoundationFinder',
    VirtualTryOn: 'VirtualTryOn',
    PersonalizedNutritionQuiz: 'PersonalizedNutritionQuiz',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticSampleSampleDtoType = {
    Sample: 'Sample',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticReportsConfigurationsBcmNewActivityReportConfigurationDtoAllowedDownlineTypesItem = {
    PgLeaders: 'PgLeaders',
    PersonalGroupPlusAuthorizedPgLeadersInFirstLevel: 'PersonalGroupPlusAuthorizedPgLeadersInFirstLevel',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticReportsConfigurationsBcmNewActivityReportConfigurationDtoAllowedActivityTypesItem = {
    FirstLevel: 'FirstLevel',
    Inactives: 'Inactives',
    NotSellingWellness: 'NotSellingWellness',
    Starters: 'Starters',
    Sleeping: 'Sleeping',
    AllBasicView: 'AllBasicView',
    Active: 'Active',
    SellingWellness: 'SellingWellness',
    AllFullView: 'AllFullView',
    ExpiringWalletAmount: 'ExpiringWalletAmount',
    UpgradedMembers: 'UpgradedMembers',
    NewStarters: 'NewStarters',
    Recruits: 'Recruits',
    AllStandardView: 'AllStandardView',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticReportsConfigurationsBcmNewActivityReportConfigurationDtoShowBonusesOfOtherPgLeader = {
    Yes: 'Yes',
    No: 'No',
    CheckApproval: 'CheckApproval',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticReportsConfigurationsBcmNewActivityReportConfigurationDtoAllowDrillDownToOtherLeadersPersonalGroups = {
    Yes: 'Yes',
    No: 'No',
    CheckApproval: 'CheckApproval',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticReportsConfigurationsBcmNewActivityReportConfigurationDtoAvailableToVisitorSegmentItem = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticProductsReplacementsReplacementDtoReplacementType = {
    Automatic: 'Automatic',
    Manual: 'Manual',
    Subscription: 'Subscription',
    Alternative: 'Alternative',
    WellnessAutomatic: 'WellnessAutomatic',
    WellnessManual: 'WellnessManual',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticProductsRelationRelationType = {
    Undefined: 'Undefined',
    Related: 'Related',
    RecentlyViewed: 'RecentlyViewed',
    Popular: 'Popular',
    Favourite: 'Favourite',
    Samples: 'Samples',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticProductsProductLabelsDtoProductLabelDomain = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticProductsProductLabelsDtoProductsLabelsCollectionItem = {
    None: 'None',
    NoLongerForSale: 'NoLongerForSale',
    SoldOut: 'SoldOut',
    SaleLimitation: 'SaleLimitation',
    OutOfStock: 'OutOfStock',
    NotSoldOnline: 'NotSoldOnline',
    ComingSoon: 'ComingSoon',
    LowStock: 'LowStock',
    Offer: 'Offer',
    New: 'New',
    LastChance: 'LastChance',
    ValueSet: 'ValueSet',
    Hidden: 'Hidden',
    SuperDeal: 'SuperDeal',
    AddToBasketVisible: 'AddToBasketVisible',
    BackInStock: 'BackInStock',
    CanBeReserved: 'CanBeReserved',
    ShowBackOrder: 'ShowBackOrder',
    NewEdition: 'NewEdition',
    NewEditionAvailable: 'NewEditionAvailable',
    CanBeSubscribed: 'CanBeSubscribed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticProductsProductDtoItemCategory = {
    Unknown: 'Unknown',
    Cosmetics: 'Cosmetics',
    AddOns: 'AddOns',
    Jewellery: 'Jewellery',
    Other: 'Other',
    PrintingMaterial: 'PrintingMaterial',
    Wellness: 'Wellness',
    Fee: 'Fee',
    DemoProduct: 'DemoProduct',
    Packaging: 'Packaging',
    Training: 'Training',
    RecruitmentGifts: 'RecruitmentGifts',
    NonFinancial: 'NonFinancial',
    OtherSample: 'OtherSample',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticProductsProductDtoProductType = {
    Product: 'Product',
    Bundle: 'Bundle',
    Sample: 'Sample',
    Fee: 'Fee',
    Composite: 'Composite',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticParentalConsentRegistrationParentalConsentMetadataDtoParentalConsentMode = {
    ParentalInfo: 'ParentalInfo',
    InfoMessage: 'InfoMessage',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticOlapicOlapicConfigurationDtoType = {
    Category: 'Category',
    FrontPage: 'FrontPage',
    Gallery: 'Gallery',
    ProductDetails: 'ProductDetails',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticNavigationNavigationItemDtoType = {
    TopNavigation: 'TopNavigation',
    ShopSection: 'ShopSection',
    AboutTiles: 'AboutTiles',
    JoinTiles: 'JoinTiles',
    InspirationTiles: 'InspirationTiles',
    Footer: 'Footer',
    TopAreaNavigation: 'TopAreaNavigation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticNavigationNavigationItemDtoLinkType = {
    None: 'None',
    MenuTiles: 'MenuTiles',
    TopNavigation: 'TopNavigation',
    FocusPage: 'FocusPage',
    Category: 'Category',
    SubCategory: 'SubCategory',
    Segment: 'Segment',
    OutletShop: 'OutletShop',
    JoinRewards: 'JoinRewards',
    RewardsShop: 'RewardsShop',
    SampleShop: 'SampleShop',
    Catalogue: 'Catalogue',
    DigitalCatalogueCurrent: 'DigitalCatalogueCurrent',
    DigitalCatalogueNext: 'DigitalCatalogueNext',
    Catalogues: 'Catalogues',
    PopularProducts: 'PopularProducts',
    PopularBrands: 'PopularBrands',
    PopularBrand: 'PopularBrand',
    PopularLookbook: 'PopularLookbook',
    KeyIngredients: 'KeyIngredients',
    WhatsNewInCategory: 'WhatsNewInCategory',
    IconsInCategory: 'IconsInCategory',
    BestsellersInCategory: 'BestsellersInCategory',
    New: 'New',
    Icons: 'Icons',
    Bestsellers: 'Bestsellers',
    Inspiration: 'Inspiration',
    AllCategory: 'AllCategory',
    SupportCenter: 'SupportCenter',
    IDontKnowYet: 'IDontKnowYet',
    FooterColumn: 'FooterColumn',
    FooterColumnItem: 'FooterColumnItem',
    Bottom: 'Bottom',
    BottomCopyright: 'BottomCopyright',
    BottomLinks: 'BottomLinks',
    PaymentMethods: 'PaymentMethods',
    PaymentMethod: 'PaymentMethod',
    QRTR: 'QRTR',
    OurApps: 'OurApps',
    BeautyTips: 'BeautyTips',
    Gifts: 'Gifts',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticNavigationBffNavigationItemDtoType = {
    TopNavigation: 'TopNavigation',
    ShopSection: 'ShopSection',
    AboutTiles: 'AboutTiles',
    JoinTiles: 'JoinTiles',
    InspirationTiles: 'InspirationTiles',
    Footer: 'Footer',
    TopAreaNavigation: 'TopAreaNavigation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticNavigationBffNavigationItemDtoLinkType = {
    None: 'None',
    MenuTiles: 'MenuTiles',
    TopNavigation: 'TopNavigation',
    FocusPage: 'FocusPage',
    Category: 'Category',
    SubCategory: 'SubCategory',
    Segment: 'Segment',
    OutletShop: 'OutletShop',
    JoinRewards: 'JoinRewards',
    RewardsShop: 'RewardsShop',
    SampleShop: 'SampleShop',
    Catalogue: 'Catalogue',
    DigitalCatalogueCurrent: 'DigitalCatalogueCurrent',
    DigitalCatalogueNext: 'DigitalCatalogueNext',
    Catalogues: 'Catalogues',
    PopularProducts: 'PopularProducts',
    PopularBrands: 'PopularBrands',
    PopularBrand: 'PopularBrand',
    PopularLookbook: 'PopularLookbook',
    KeyIngredients: 'KeyIngredients',
    WhatsNewInCategory: 'WhatsNewInCategory',
    IconsInCategory: 'IconsInCategory',
    BestsellersInCategory: 'BestsellersInCategory',
    New: 'New',
    Icons: 'Icons',
    Bestsellers: 'Bestsellers',
    Inspiration: 'Inspiration',
    AllCategory: 'AllCategory',
    SupportCenter: 'SupportCenter',
    IDontKnowYet: 'IDontKnowYet',
    FooterColumn: 'FooterColumn',
    FooterColumnItem: 'FooterColumnItem',
    Bottom: 'Bottom',
    BottomCopyright: 'BottomCopyright',
    BottomLinks: 'BottomLinks',
    PaymentMethods: 'PaymentMethods',
    PaymentMethod: 'PaymentMethod',
    QRTR: 'QRTR',
    OurApps: 'OurApps',
    BeautyTips: 'BeautyTips',
    Gifts: 'Gifts',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMobileOfficeModulesVisibilityDtoEarningsOnDashboardVisitorSegmentsItem = {
    NotDefined: 'NotDefined',
    Anonymous: 'Anonymous',
    NewConsultant: 'NewConsultant',
    Consultant: 'Consultant',
    Manager: 'Manager',
    DirectorAndAbove: 'DirectorAndAbove',
    EndCustomer: 'EndCustomer',
    Member: 'Member',
    Spo: 'Spo',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMobileAppsMobileAppTypeDtoType = {
    None: 'None',
    ToSell: 'ToSell',
    ToShop: 'ToShop',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticManagerSeminarParamsMinDiscountRateQualificationDtoDiscountRateLevel = {
    LevelBasic: 'LevelBasic',
    Level10: 'Level10',
    Level20: 'Level20',
    Level30: 'Level30',
    Level40: 'Level40',
    Level50: 'Level50',
    Level60: 'Level60',
    LevelMax: 'LevelMax',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7ProductsProductReplacementsDtoReplacementType = {
    Automatic: 'Automatic',
    Manual: 'Manual',
    Subscription: 'Subscription',
    Alternative: 'Alternative',
    WellnessAutomatic: 'WellnessAutomatic',
    WellnessManual: 'WellnessManual',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7ProductListingsProductListingPromoItemDtoType = {
    Product: 'Product',
    PromoBanner: 'PromoBanner',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7PersonalizedNutritionQuizQuestionsQuizQuestionConfigurationQuestionType = {
    Unknown: 'Unknown',
    SingleAnswer: 'SingleAnswer',
    Multiselect: 'Multiselect',
    MultiselectGrid: 'MultiselectGrid',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7HomepageModulesIconicProductsBannerDtoBackgroundColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7HomepageModulesEditorialPagesMixedContentItemDtoStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7HomepageModulesEditorialPagesMixedContentItemDtoEditorialContentType = {
    Header: 'Header',
    Banner: 'Banner',
    Olapic: 'Olapic',
    ProductBoxCarousel: 'ProductBoxCarousel',
    EditorialCarousel: 'EditorialCarousel',
    MixedPlpContent: 'MixedPlpContent',
    EditorialBannerCarousel: 'EditorialBannerCarousel',
    TestimonialCarousel: 'TestimonialCarousel',
    FrequentlyAskedQuestions: 'FrequentlyAskedQuestions',
    LinkList: 'LinkList',
    FiftyBanner: 'FiftyBanner',
    Benefits: 'Benefits',
    LinkCarousel: 'LinkCarousel',
    Table: 'Table',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7HomepageModulesEditorialPagesMixedContentItemDtoBackgroundType = {
    None: 'None',
    Image: 'Image',
    Video: 'Video',
    Color: 'Color',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7HomepageModulesEditorialPagesMixedContentItemDtoLayout = {
    ThreeMediaRightBottomText: 'ThreeMediaRightBottomText',
    Quote: 'Quote',
    ParagraphText: 'ParagraphText',
    TwoMedia: 'TwoMedia',
    Headline: 'Headline',
    OneMediaParagraphText: 'OneMediaParagraphText',
    Video: 'Video',
    OneMediaOverlayLeftText: 'OneMediaOverlayLeftText',
    OneMediaOverlayRightText: 'OneMediaOverlayRightText',
    OneMediaCenterBottomText: 'OneMediaCenterBottomText',
    TwoMediaRightTopText: 'TwoMediaRightTopText',
    FourMedia: 'FourMedia',
    OneMediaProductPromo: 'OneMediaProductPromo',
    VerticalVideo: 'VerticalVideo',
    FiftyBanner: 'FiftyBanner',
    BigCtaButton: 'BigCtaButton',
    SmallCtaButton: 'SmallCtaButton',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7HomepageModulesEditorialPagesMixedContentItemDtoBackgroundStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7HomepageModulesEditorialPagesEditorialBannerModuleDtoBackgroundType = {
    None: 'None',
    Image: 'Image',
    Video: 'Video',
    Color: 'Color',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7HomepageModulesEditorialPagesEditorialBannerModuleDtoBackgroundStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7HomepageModulesEditorialPagesBannerTextLinkDtoType = {
    Product: 'Product',
    Brand: 'Brand',
    PLpage: 'PLpage',
    EditorialArticle: 'EditorialArticle',
    Invite: 'Invite',
    Custom: 'Custom',
    Category: 'Category',
    NewProducts: 'NewProducts',
    Catalogue: 'Catalogue',
    Campaign: 'Campaign',
    NovageSkincareAdvisor: 'NovageSkincareAdvisor',
    EditorialCampaign: 'EditorialCampaign',
    Ingredient: 'Ingredient',
    SignIn: 'SignIn',
    Frontpage: 'Frontpage',
    RegistrationPage: 'RegistrationPage',
    InvitationOffer: 'InvitationOffer',
    Brands: 'Brands',
    FoundationFinder: 'FoundationFinder',
    VirtualTryOn: 'VirtualTryOn',
    PersonalizedNutritionQuiz: 'PersonalizedNutritionQuiz',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7HomepageModulesEditorialLandingPagesLinkDtoType = {
    Product: 'Product',
    Brand: 'Brand',
    PLpage: 'PLpage',
    EditorialArticle: 'EditorialArticle',
    Invite: 'Invite',
    Custom: 'Custom',
    Category: 'Category',
    NewProducts: 'NewProducts',
    Catalogue: 'Catalogue',
    Campaign: 'Campaign',
    NovageSkincareAdvisor: 'NovageSkincareAdvisor',
    EditorialCampaign: 'EditorialCampaign',
    Ingredient: 'Ingredient',
    SignIn: 'SignIn',
    Frontpage: 'Frontpage',
    RegistrationPage: 'RegistrationPage',
    InvitationOffer: 'InvitationOffer',
    Brands: 'Brands',
    FoundationFinder: 'FoundationFinder',
    VirtualTryOn: 'VirtualTryOn',
    PersonalizedNutritionQuiz: 'PersonalizedNutritionQuiz',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticMV7HomepageModulesBestsellerProductsBannerDtoBackgroundColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticLanguagesLanguageType = {
    Default: 'Default',
    Alternative: 'Alternative',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticEditorialArticlesEditorialArticleDtoArticleType = {
    BeautyEdit: 'BeautyEdit',
    RelatedToProduct: 'RelatedToProduct',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticECatalogueStructureImageDtoType = {
    Unknown: 'Unknown',
    Thumb: 'Thumb',
    Normal: 'Normal',
    Zoom: 'Zoom',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticDocumentsDocumentTypeDtoDocumentCategory = {
    General: 'General',
    CreditRequest: 'CreditRequest',
    Personal: 'Personal',
    Claim: 'Claim',
    Legal: 'Legal',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticDocumentsDocumentTypeDtoDocumentTag = {
    NotSpecified: 'NotSpecified',
    IdentityCard: 'IdentityCard',
    Passport: 'Passport',
    ProfileImage: 'ProfileImage',
    DamageParcel: 'DamageParcel',
    DamageCover: 'DamageCover',
    BankAccount: 'BankAccount',
    WellnessSellingApplication: 'WellnessSellingApplication',
    WellnessSellingCertificate: 'WellnessSellingCertificate',
    Caf: 'Caf',
    Commitment: 'Commitment',
    Annex: 'Annex',
    DamagedProduct: 'DamagedProduct',
    ExportedFile: 'ExportedFile',
    Custom: 'Custom',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticDigitalPromotionsCurrentPromotionDtoChannel = {
    Website: 'Website',
    MV7: 'MV7',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticDigitalPromotionsCurrentPromotionDtoPromotionType = {
    BestOffers: 'BestOffers',
    WhatsNew: 'WhatsNew',
    Hero: 'Hero',
    Campaign: 'Campaign',
    Category: 'Category',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticDeprecatedProductDtoProductType = {
    Product: 'Product',
    Bundle: 'Bundle',
    Sample: 'Sample',
    Fee: 'Fee',
    Composite: 'Composite',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticDeliveryDeliveryMethodDtoType = {
    ParcelLocker: 'ParcelLocker',
    DepartmentStore: 'DepartmentStore',
    Home: 'Home',
    Lpo: 'Lpo',
    NextOrder: 'NextOrder',
    PostOffice: 'PostOffice',
    PickupPoint: 'PickupPoint',
    Spo: 'Spo',
    NearestPostOffice: 'NearestPostOffice',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCustomersMetadataCustomerApprovalSharedMetadataDtoDefaultStatus = {
    Expanded: 'Expanded',
    Collapsed: 'Collapsed',
    Disabled: 'Disabled',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCustomersMetadataAddressSearchMetadataDtoAllowedSearchResultsItem = {
    Market: 'Market',
    Country: 'Country',
    Region: 'Region',
    Province: 'Province',
    District: 'District',
    Area: 'Area',
    City: 'City',
    Locality: 'Locality',
    Street: 'Street',
    ZipCode: 'ZipCode',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCustomerRegistrationsMetadataRegistrationSponsorDetailsMetadataDtoPreselectedSponsorSelectionMethod = {
    ManualInput: 'ManualInput',
    SponsorLocator: 'SponsorLocator',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCustomerRegistrationInstructionsMetadataCustomerRegistrationInstructionsMetadataDtoEnabledRegistrationTypesItem = {
    SelfBrandPartner: 'SelfBrandPartner',
    SelfVip: 'SelfVip',
    SponsorBrandPartner: 'SponsorBrandPartner',
    SponsorVip: 'SponsorVip',
    Checkout: 'Checkout',
    SponsorOnBehalf: 'SponsorOnBehalf',
    SelfOnBehalf: 'SelfOnBehalf',
    SocialNetworks: 'SocialNetworks',
    SelfOnBehalfVip: 'SelfOnBehalfVip',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCustomerExternalProfilesMetadataExternalProfilesMetadataDtoAvailableOptionsItem = {
    Google: 'Google',
    Facebook: 'Facebook',
    VKontakte: 'VKontakte',
    ActiveDirectory: 'ActiveDirectory',
    WeChat: 'WeChat',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCulturePointsFormatDtoCurrency = {
    Points: 'Points',
    Hearts: 'Hearts',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticConceptsConceptLabelsDtoConceptLabelDomain = {
    Undefined: 'Undefined',
    PPA: 'PPA',
    Deal: 'Deal',
    Shopping: 'Shopping',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticConceptsConceptLabelsDtoConceptLabelsCollectionItem = {
    None: 'None',
    NoLongerForSale: 'NoLongerForSale',
    SoldOut: 'SoldOut',
    SaleLimitation: 'SaleLimitation',
    OutOfStock: 'OutOfStock',
    NotSoldOnline: 'NotSoldOnline',
    ComingSoon: 'ComingSoon',
    LowStock: 'LowStock',
    Offer: 'Offer',
    New: 'New',
    LastChance: 'LastChance',
    ValueSet: 'ValueSet',
    Hidden: 'Hidden',
    SuperDeal: 'SuperDeal',
    AddToBasketVisible: 'AddToBasketVisible',
    BackInStock: 'BackInStock',
    CanBeReserved: 'CanBeReserved',
    ShowBackOrder: 'ShowBackOrder',
    NewEdition: 'NewEdition',
    NewEditionAvailable: 'NewEditionAvailable',
    CanBeSubscribed: 'CanBeSubscribed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCampaignsRewardShopConfigurationDtoCustomerCategory = {
    Anonymous: 'Anonymous',
    Consultant: 'Consultant',
    EndConsumer: 'EndConsumer',
    Invitation: 'Invitation',
    Employee: 'Employee',
    EndCustomer: 'EndCustomer',
    Other: 'Other',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCampaignsCampaignDtoType = {
    InvitedRecruits: 'InvitedRecruits',
    Loyalty: 'Loyalty',
    VipLoyalty: 'VipLoyalty',
    Mgm: 'Mgm',
    LightVipLoyalty: 'LightVipLoyalty',
    MmLoyalty: 'MmLoyalty',
    Gamification: 'Gamification',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticCampaignsCampaignDtoCategory = {
    Recruitment: 'Recruitment',
    Loyalty: 'Loyalty',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticBonusesParametersNewTitleBracketDtoCutOffTitleType = {
    TitleAndQualification: 'TitleAndQualification',
    TitleOrQualification: 'TitleOrQualification',
    Title: 'Title',
    Qualification: 'Qualification',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticBonusesParametersNewTitleBracketDtoTargetMaxTitleCode = {
    A: 'A',
    B: 'B',
    C: 'C',
    CS: 'CS',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G',
    H: 'H',
    I: 'I',
    J: 'J',
    K: 'K',
    L: 'L',
    M: 'M',
    N: 'N',
    O: 'O',
    P: 'P',
    Q: 'Q',
    R: 'R',
    S: 'S',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticBonusesParametersNewComerBracketDtoTargetDiscountRateLevel = {
    LevelBasic: 'LevelBasic',
    Level10: 'Level10',
    Level20: 'Level20',
    Level30: 'Level30',
    Level40: 'Level40',
    Level50: 'Level50',
    Level60: 'Level60',
    LevelMax: 'LevelMax',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticBonusesParametersNewComerBracketDtoBaseNewComerType = {
    NewBrandPartner: 'NewBrandPartner',
    UpgradedMember: 'UpgradedMember',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticBonusesParametersManagerBracketDtoTargetDiscountRateLevel = {
    LevelBasic: 'LevelBasic',
    Level10: 'Level10',
    Level20: 'Level20',
    Level30: 'Level30',
    Level40: 'Level40',
    Level50: 'Level50',
    Level60: 'Level60',
    LevelMax: 'LevelMax',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticBonusesParametersManagerBracketDtoInitialDiscountRateLevel = {
    LevelBasic: 'LevelBasic',
    Level10: 'Level10',
    Level20: 'Level20',
    Level30: 'Level30',
    Level40: 'Level40',
    Level50: 'Level50',
    Level60: 'Level60',
    LevelMax: 'LevelMax',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticBonusesParametersDirectorBracketDtoCutOffTitleCode = {
    A: 'A',
    B: 'B',
    C: 'C',
    CS: 'CS',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G',
    H: 'H',
    I: 'I',
    J: 'J',
    K: 'K',
    L: 'L',
    M: 'M',
    N: 'N',
    O: 'O',
    P: 'P',
    Q: 'Q',
    R: 'R',
    S: 'S',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticBonusesParametersDirectorBracketDtoTargetTitleCode = {
    A: 'A',
    B: 'B',
    C: 'C',
    CS: 'CS',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G',
    H: 'H',
    I: 'I',
    J: 'J',
    K: 'K',
    L: 'L',
    M: 'M',
    N: 'N',
    O: 'O',
    P: 'P',
    Q: 'Q',
    R: 'R',
    S: 'S',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticBonusesCommissionPlanTypeDtoCommissionPlanType = {
    SuccessPlan: 'SuccessPlan',
    MatureMarkets: 'MatureMarkets',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsProductListingsV2MixedPlpContentDtoSize = {
    Size1: 'Size1',
    Size2: 'Size2',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsProductListingsV2EditorialBannerModuleDtoBackgroundStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsProductListingsV2EditorialBannerContentDtoVerticalAlignment = {
    Undefined: 'Undefined',
    Top: 'Top',
    Middle: 'Middle',
    Bottom: 'Bottom',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsProductListingsV2EditorialBannerContentDtoTitleStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsProductListingsProductSortDefinitionDtoOrderBy = {
    Recommended: 'Recommended',
    Latest: 'Latest',
    HighestRating: 'HighestRating',
    LowestPrice: 'LowestPrice',
    HighestPrice: 'HighestPrice',
    HighestDiscount: 'HighestDiscount',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsPersonalBeautyStorePbsConfigurationDtoBeautyStoreType = {
    PbsStandard: 'PbsStandard',
    PbsLite: 'PbsLite',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsNewsletterSubsciptionConfigurationResponseMessageType = {
    Unknown: 'Unknown',
    New: 'New',
    Subscribed: 'Subscribed',
    Pending: 'Pending',
    Unsubscribed: 'Unsubscribed',
    Cleaned: 'Cleaned',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFrontpageV3VideoDtoType = {
    None: 'None',
    Mp4: 'Mp4',
    Youtube: 'Youtube',
    Youku: 'Youku',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFrontpageV3ProductsPromotionBannerDtoBackgroundColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFrontpageV3ProductsPromotionBannerDtoFontColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFrontpageV3NotificationBannerDtoMessageTheme = {
    Black: 'Black',
    Grey: 'Grey',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffSocialMediaLinkDtoType = {
    Facebook: 'Facebook',
    VKontakte: 'VKontakte',
    Twitter: 'Twitter',
    YouTube: 'YouTube',
    Instagram: 'Instagram',
    Pinterest: 'Pinterest',
    Odnoklassniki: 'Odnoklassniki',
    Weibo: 'Weibo',
    QQ: 'QQ',
    Youku: 'Youku',
    Line: 'Line',
    WeChat: 'WeChat',
    Telegram: 'Telegram',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffResponseMessageDtoType = {
    Unknown: 'Unknown',
    New: 'New',
    Subscribed: 'Subscribed',
    Pending: 'Pending',
    Unsubscribed: 'Unsubscribed',
    Cleaned: 'Cleaned',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffNavigationItemDtoLinkType = {
    None: 'None',
    MenuTiles: 'MenuTiles',
    TopNavigation: 'TopNavigation',
    FocusPage: 'FocusPage',
    Category: 'Category',
    SubCategory: 'SubCategory',
    Segment: 'Segment',
    OutletShop: 'OutletShop',
    JoinRewards: 'JoinRewards',
    RewardsShop: 'RewardsShop',
    SampleShop: 'SampleShop',
    Catalogue: 'Catalogue',
    DigitalCatalogueCurrent: 'DigitalCatalogueCurrent',
    DigitalCatalogueNext: 'DigitalCatalogueNext',
    Catalogues: 'Catalogues',
    PopularProducts: 'PopularProducts',
    PopularBrands: 'PopularBrands',
    PopularBrand: 'PopularBrand',
    PopularLookbook: 'PopularLookbook',
    KeyIngredients: 'KeyIngredients',
    WhatsNewInCategory: 'WhatsNewInCategory',
    IconsInCategory: 'IconsInCategory',
    BestsellersInCategory: 'BestsellersInCategory',
    New: 'New',
    Icons: 'Icons',
    Bestsellers: 'Bestsellers',
    Inspiration: 'Inspiration',
    AllCategory: 'AllCategory',
    SupportCenter: 'SupportCenter',
    IDontKnowYet: 'IDontKnowYet',
    FooterColumn: 'FooterColumn',
    FooterColumnItem: 'FooterColumnItem',
    Bottom: 'Bottom',
    BottomCopyright: 'BottomCopyright',
    BottomLinks: 'BottomLinks',
    PaymentMethods: 'PaymentMethods',
    PaymentMethod: 'PaymentMethod',
    QRTR: 'QRTR',
    OurApps: 'OurApps',
    BeautyTips: 'BeautyTips',
    Gifts: 'Gifts',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffNavigationDtoNavigationType = {
    TopNavigation: 'TopNavigation',
    ShopSection: 'ShopSection',
    AboutTiles: 'AboutTiles',
    JoinTiles: 'JoinTiles',
    InspirationTiles: 'InspirationTiles',
    Footer: 'Footer',
    TopAreaNavigation: 'TopAreaNavigation',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffMobileAppMobileAppTypeDtoType = {
    None: 'None',
    ToSell: 'ToSell',
    ToShop: 'ToShop',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsFooterBffLanguageDtoType = {
    Default: 'Default',
    Alternative: 'Alternative',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialProductListingProductDtoPosition = {
    Position1: 'Position1',
    Position2: 'Position2',
    Position3: 'Position3',
    Position4: 'Position4',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialProductListingBannerDtoSize = {
    Size1: 'Size1',
    Size2: 'Size2',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialProductListingBannerDtoPosition = {
    Position1: 'Position1',
    Position2: 'Position2',
    Position3: 'Position3',
    Position4: 'Position4',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialOlapicDtoType = {
    Category: 'Category',
    FrontPage: 'FrontPage',
    Gallery: 'Gallery',
    ProductDetails: 'ProductDetails',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialMixedPlpContentDtoListingModifier = {
    None: 'None',
    Outlet: 'Outlet',
    New: 'New',
    SampleShop: 'SampleShop',
    Icons: 'Icons',
    Bestsellers: 'Bestsellers',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialMixedPlpContentDtoListingType = {
    Manual: 'Manual',
    Category: 'Category',
    Brand: 'Brand',
    SampleShop: 'SampleShop',
    Outlet: 'Outlet',
    New: 'New',
    Icons: 'Icons',
    Bestsellers: 'Bestsellers',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialLandingPageDtoBackgroundStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialLandingPageDtoHeadlineStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialLandingPageDtoTitleColor = {
    Black: 'Black',
    DarkGrey: 'DarkGrey',
    White: 'White',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialHeaderDtoHeadlineStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialHeaderDtoBackgroundStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialFiftyBannerDtoBackgroundStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialFiftyBannerDtoBackgroundType = {
    None: 'None',
    Image: 'Image',
    Video: 'Video',
    Color: 'Color',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialFiftyBannerDtoContentAlignment = {
    Undefined: 'Undefined',
    Left: 'Left',
    Right: 'Right',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerModuleDtoBackgroundStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerModuleDtoBackgroundType = {
    None: 'None',
    Image: 'Image',
    Video: 'Video',
    Color: 'Color',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerDtoLayout = {
    ThreeMediaRightBottomText: 'ThreeMediaRightBottomText',
    Quote: 'Quote',
    ParagraphText: 'ParagraphText',
    TwoMedia: 'TwoMedia',
    Headline: 'Headline',
    OneMediaParagraphText: 'OneMediaParagraphText',
    Video: 'Video',
    OneMediaOverlayLeftText: 'OneMediaOverlayLeftText',
    OneMediaOverlayRightText: 'OneMediaOverlayRightText',
    OneMediaCenterBottomText: 'OneMediaCenterBottomText',
    TwoMediaRightTopText: 'TwoMediaRightTopText',
    FourMedia: 'FourMedia',
    OneMediaProductPromo: 'OneMediaProductPromo',
    VerticalVideo: 'VerticalVideo',
    FiftyBanner: 'FiftyBanner',
    BigCtaButton: 'BigCtaButton',
    SmallCtaButton: 'SmallCtaButton',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerContentDtoHorizontalAlignment = {
    Undefined: 'Undefined',
    Left: 'Left',
    Right: 'Right',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerContentDtoVerticalAlignment = {
    Undefined: 'Undefined',
    Top: 'Top',
    Middle: 'Middle',
    Bottom: 'Bottom',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerContentDtoTitleSize = {
    H5: 'H5',
    H6: 'H6',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerContentDtoTitleStorybookColor = {
    Undefined: 'Undefined',
    TextPrimary: 'TextPrimary',
    TextSecondary: 'TextSecondary',
    DefaultContrastText: 'DefaultContrastText',
    SecondaryMain: 'SecondaryMain',
    Grey50: 'Grey50',
    DefaultMain: 'DefaultMain',
    Brown300: 'Brown300',
    Purple200: 'Purple200',
    PrimaryLight: 'PrimaryLight',
    Pink50: 'Pink50',
    Brown50: 'Brown50',
    Blue100: 'Blue100',
    Yellow50: 'Yellow50',
    Red50: 'Red50',
    Purple50: 'Purple50',
    Purple400: 'Purple400',
    Green400: 'Green400',
    Pink300: 'Pink300',
    Brown400: 'Brown400',
    InfoDark: 'InfoDark',
    Yellow400: 'Yellow400',
    Green50: 'Green50',
    CommonWhite: 'CommonWhite',
    Grey700: 'Grey700',
    Grey900: 'Grey900',
    PrimaryContrastText: 'PrimaryContrastText',
    PrimaryMain: 'PrimaryMain',
    Grey100: 'Grey100',
    Green200: 'Green200',
    SecondaryContrastText: 'SecondaryContrastText',
    CommonBlack: 'CommonBlack',
    Brown100: 'Brown100',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialEditorialBannerContentDtoTitleColor = {
    Black: 'Black',
    DarkGrey: 'DarkGrey',
    White: 'White',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialContentDtoType = {
    Header: 'Header',
    Banner: 'Banner',
    Olapic: 'Olapic',
    ProductBoxCarousel: 'ProductBoxCarousel',
    EditorialCarousel: 'EditorialCarousel',
    MixedPlpContent: 'MixedPlpContent',
    EditorialBannerCarousel: 'EditorialBannerCarousel',
    TestimonialCarousel: 'TestimonialCarousel',
    FrequentlyAskedQuestions: 'FrequentlyAskedQuestions',
    LinkList: 'LinkList',
    FiftyBanner: 'FiftyBanner',
    Benefits: 'Benefits',
    LinkCarousel: 'LinkCarousel',
    Table: 'Table',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialBenefitDtoIcon = {
    Check: 'Check',
    Dollar: 'Dollar',
    Send: 'Send',
    WelcomeKit: 'WelcomeKit',
    Conference: 'Conference',
    BubbleHeart: 'BubbleHeart',
    Share: 'Share',
    Wallet: 'Wallet',
    Truck: 'Truck',
    Cashback: 'Cashback',
    DiscountTag: 'DiscountTag',
    Gift: 'Gift',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialBackgroundVideoDtoType = {
    Mp4: 'Mp4',
    Youtube: 'Youtube',
    Youku: 'Youku',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsEditorialBackgroundColorDtoType = {
    White: 'White',
    Brown: 'Brown',
    Green: 'Green',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsCategoryPlpCategoryPlpPromoBannerRowMixedContentDtoSize = {
    Size1: 'Size1',
    Size2: 'Size2',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsCategoryPlpCategoryPlpPromoBannerContentDtoVerticalAlignment = {
    Undefined: 'Undefined',
    Top: 'Top',
    Middle: 'Middle',
    Bottom: 'Bottom',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsCategoryPlpCategoryPlpPromoBannerContentDtoTitleColor = {
    Black: 'Black',
    DarkGrey: 'DarkGrey',
    White: 'White',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsCatalogueOverviewCatalogueDtoCatalogueType = {
    None: 'None',
    DigitalCurrent: 'DigitalCurrent',
    DigitalNext: 'DigitalNext',
    LocalCustom: 'LocalCustom',
    Lookbook: 'Lookbook',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsCatalogueOverviewCataloguMetadataDtoProviderType = {
    None: 'None',
    Online: 'Online',
    IPaper: 'IPaper',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsBrandPlpBrandPlpPromoBannerRowMixedContentDtoSize = {
    Size1: 'Size1',
    Size2: 'Size2',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsBrandPlpBrandPlpPromoBannerContentDtoVerticalAlignment = {
    Undefined: 'Undefined',
    Top: 'Top',
    Middle: 'Middle',
    Bottom: 'Bottom',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsBrandPlpBrandPlpPromoBannerContentDtoTitleColor = {
    Black: 'Black',
    DarkGrey: 'DarkGrey',
    White: 'White',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticApplicationsBannersFeedbackBenefitBannerDtoBannerType = {
    ShareAndEarn: 'ShareAndEarn',
    Cashback: 'Cashback',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticAddressFormatsAddressFormatLineDtoFieldsItem = {
    AddressType: 'AddressType',
    Country: 'Country',
    Region: 'Region',
    Province: 'Province',
    District: 'District',
    Area: 'Area',
    City: 'City',
    Locality: 'Locality',
    StreetAddress: 'StreetAddress',
    ZipCode: 'ZipCode',
    Delivery: 'Delivery',
    CustomerName: 'CustomerName',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var StaticAddressFormatsAddressFormatDtoType = {
    SingleLine: 'SingleLine',
    MultiLine: 'MultiLine',
    CustomerMultiLine: 'CustomerMultiLine',
    Searched: 'Searched',
};

//# sourceMappingURL=api.schemas.js.map
